<template>
  <div class="relative mb-24px overflow-hidden">
    <p class="flex justify-between pl-16px pr-4px title-14-h16-m text-primary-100">
      <span>{{ title }} </span>
      <span
        v-if="cardContent.length > 2"
        class="flex cursor-pointer items-center content-12-h16-r text-deep-brown"
        @click="$router.push({ hash: `#${expandHandle}` })"
        >{{ $t('checkout.more') }}
        <i class="icon-chevron-right ml-8px text-20px" />
      </span>
    </p>
    <div
      ref="container"
      class="relative mt-8px scrollbar-hide w-full flex snap-x snap-mandatory scroll-px-4px gap-4px overflow-x-auto p-4px"
      @scroll="onMobileContainerScroll"
    >
      <!--   mobile 版本固定顯示 12 張卡   -->
      <DisplayCard
        v-for="(item, index) in cardContent.slice(0, 12)"
        :key="index"
        class="snap-start"
        :content="item"
      />
      <div
        v-if="cardContent.length > 2"
        class="black-transparent-cover absolute h-260px w-180px flex items-center justify-center rounded-5px"
        :style="{ left: `${coverPosition}px` }"
      >
        <AuButton
          icon-name="arrow-right"
          icon-right
          @click="$router.push({ hash: `#${expandHandle}` })"
          >{{ $t('checkout.more') }}</AuButton
        >
      </div>
    </div>
    <div
      v-if="scrollArrowsVisibility.left"
      class="scroll-button left-2px"
      @click="scrollByButton('left')"
    >
      <i class="icon-chevron-left" />
    </div>
    <div
      v-if="scrollArrowsVisibility.right"
      class="scroll-button right-2px"
      @click="scrollByButton('right')"
    >
      <i class="icon-chevron-right" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { AuButton } from '@evolutivelabs/amuse-ui'
import { computed, onMounted, ref, useTemplateRef } from 'vue'

import { type DisplayCardContent } from '@/components/DisplayCards/DisplayCard'
import DisplayCard from '@/components/DisplayCards/DisplayCard.vue'

const props = defineProps<{
  cardContent: DisplayCardContent[]
  expandHandle: string
  title: string
}>()

onMounted(() => {
  if (props.cardContent.length > 2) scrollArrowsVisibility.value.right = true
})

const container = useTemplateRef<HTMLElement>('container')
const coverPosition = computed(() => {
  if (container.value === null) return
  // containerWidth - card width - left padding
  return container.value.scrollWidth - 180 - 4
})
const scrollArrowsVisibility = ref({ left: false, right: false })
function onMobileContainerScroll(): void {
  if (container.value === null) return
  const { scrollLeft, scrollWidth, clientWidth } = container.value
  scrollArrowsVisibility.value.left = scrollLeft > 130
  scrollArrowsVisibility.value.right = scrollWidth - clientWidth - scrollLeft > 130
}
function scrollByButton(direction: 'left' | 'right'): void {
  if (container.value === null) return
  // +- card width
  const newPosition =
    direction === 'left' ? container.value.scrollLeft - 180 : container.value.scrollLeft + 180
  container.value.scrollTo({
    left: newPosition,
    behavior: 'smooth',
  })
}
</script>

<style scoped>
.black-transparent-cover {
  background: rgba(186, 186, 186, 0.5);
}
.scroll-button {
  @apply z-1 cursor-pointer absolute right-2px top-110px h-24px w-24px flex items-center justify-center rounded-full bg-white text-24px text-primary-50 shadow-dropdown;
}
</style>
